import { createContext, useContext } from 'react'

// Presentation metadata from the existing club bootstrap. This context never
// participates in availability calculations, request identities or mutations.
export const MemberTimeZoneContext = createContext(undefined)
export const useMemberTimeZone = () => useContext(MemberTimeZoneContext)
